import { useLocalStorage } from 'usehooks-ts';
import { ProductType } from './useProducts';

type ProductLeverageMap = {
  [productId: string]: number;
};

export const useProductLeverage = (product: ProductType) => {
  const [leverageMap, setLeverageMap] = useLocalStorage<ProductLeverageMap>(
    'product-leverage-map',
    {}
  );

  const setLeverage = (leverage: number | undefined) => {
    if (leverage === undefined) {
      removeLeverage();
    } else if (leverage > 0 && leverage <= product.maxLeverage) {
      setLeverageMap((currentMap) => ({
        ...currentMap,
        [product.id]: leverage,
      }));
    } else {
      throw new Error(
        `Invalid leverage ${leverage}. Must be greater than 0 and less than or equal to ${product.maxLeverage}.`
      );
    }
  };

  const removeLeverage = () => {
    setLeverageMap((currentMap) => {
      // Filter out productId.
      const { [product.id]: _, ...filteredMap } = currentMap;
      return filteredMap;
    });
  };

  return {
    value: Math.min(leverageMap[product.id] ?? product.maxLeverage, product.maxLeverage),
    setValue: setLeverage,
    removeValue: removeLeverage,
  };
};
